import { ReadonlyURLSearchParams } from "next/navigation";

export const normalizeUrlSearchParamsToRouterQuery = (
  searchParams: ReadonlyURLSearchParams | null,
) => {
  const normalized: Record<string, string | string[]> = {};
  if (searchParams) {
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      normalized[key] = values.length > 1 ? values : values[0];
    }
  }
  return normalized;
};
